import styled from 'styled-components';
import { getColors } from 'vmfcom-lib/utils';

const generateMargin = (margin = {}) => typeof margin === 'object'
  ? (Object.keys(margin).reduce((output, key) => {
    const val = margin[key];
    if (typeof val === 'number' || typeof val === 'string') {
      output.push(`margin-${key}: ${val};`);
    }

    return output;
  }, [])).join('\n') : '';

export default styled.section`
  background-color: ${props => getColors(props.backgroundColor).primary};
  ${props => generateMargin(props.margin)};
  border-top: 5px solid ${props => props.theme.colors.claytonGreen};
  border-bottom: 5px solid ${props => props.theme.colors.claytonGreen};

  .inner .secondary * {
    color: ${props => props.theme.colors.white};
  }
  
  .play-button-circle {
    cursor: pointer;
    position: absolute;
    top: calc(50% - 2.5rem);
    left: calc(50% - 2.5rem);
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.04);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.04);
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.04);
    box-shadow: 0px 24px 32px 0px rgba(0, 0, 0, 0.04);
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      width: 64px;
      height: 64px;
      top: calc(50% - 32px) !important;

      svg {
        width: .6rem;
        padding-left: .3rem;
      }
    }
  }

  .modal {
    .content {
      overflow: hidden;
    }
  }

  > .inner {
    display: flex;
    z-index: 2;
    position: relative;
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    justify-content: space-between;
    flex-direction: column;
    padding: 2rem 3rem 1.2rem;

    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      padding: 1rem;
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.featurette};
      flex-direction: row;
    }
    
  }

  .disclaimer {
    color: ${props => props.theme.colors.white};
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    padding: 0 3rem 1rem;

    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      padding: 1rem;
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.featurette};
    }

    * {
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
    }
    
  }

  .primary {
    position: relative;
    display: flex;
    align-items: center;
    width: 50%;

    @media (max-width: ${props => props.theme.breakpoints.desktop}) {
      width: 100%;
    }

    picture {
      width: 100%;

      img {
        width: 100%;
      }
      
    }
    
  }

  .secondary {
    padding-left: 4rem;
    width: 50%;

    @media (max-width: ${props => props.theme.breakpoints.desktop}) {
      padding-left: 0;
      width: 100%;
    }
    
  }

`;
